import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AvatarComponent } from './avatars.component';
import { AvatarsService } from './avatars.service';

@NgModule({
  imports: [CommonModule],
  declarations: [AvatarComponent],
  exports: [AvatarComponent],
  providers: [AvatarsService],
})
export class AvatarsModule {}
